import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Child, ChildDto, UpdateChild, mapFromChildDto, ChildRequestParams, mapUpdateChildToDto } from '@/app/entities';

import { getApiEndpoint } from '@/app/core/http';
import { ApiResponse, mapDataNonNull, mapListNonNull, ApiResponseNonNull } from '@/app/shared/http';

@Injectable({
  providedIn: 'root',
})
export class ChildApiService {
  private readonly http = inject(HttpClient);

  getChildren(paramsData: ChildRequestParams): Observable<ApiResponseNonNull<Child[]>> {
    const params = this.createParams(paramsData);
    return this.http
      .get<ApiResponse<ChildDto[]>>(getApiEndpoint('children'), { params })
      .pipe(mapListNonNull(mapFromChildDto));
  }

  getChildById(id: number): Observable<ApiResponseNonNull<Child>> {
    return this.http
      .get<ApiResponse<ChildDto>>(getApiEndpoint('children') + '/' + id)
      .pipe(mapDataNonNull(mapFromChildDto));
  }

  updateChild(child: UpdateChild, childId: number): Observable<ApiResponseNonNull<Child>> {
    return this.http
      .put<ApiResponse<ChildDto>>(getApiEndpoint('children') + '/' + childId, mapUpdateChildToDto(child))
      .pipe(mapDataNonNull(mapFromChildDto));
  }

  private createParams(params: ChildRequestParams): HttpParams {
    let httpParams = new HttpParams();
    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.perPage) {
      httpParams = httpParams.set('per_page', params.perPage.toString());
    }
    if (params.searchText) {
      httpParams = httpParams.set('search', params.searchText);
    }
    if (params.orderBy) {
      httpParams = httpParams.set('order_by', params.orderBy);
    }
    if (params.orderDir) {
      httpParams = httpParams.set('order_dir', params.orderDir);
    }
    if (params.gender) {
      httpParams = httpParams.set('gender', params.gender);
    }
    if (params.minAge) {
      httpParams = httpParams.set('min_age', params.minAge);
    }
    if (params.maxAge) {
      httpParams = httpParams.set('max_age', params.maxAge);
    }
    if (params.securityStatus) {
      httpParams = httpParams.set('security_status', params.securityStatus);
    }
    return httpParams;
  }
}
